<public>

  <div id="box-copter-hero">
      <div id="box-copter-hero-form-wrapper" fxLayout="column" fxLayoutAlign="start start" fxFlex="100">
          <div id="box-copter-hero-form">
              <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutAlign="start start">
                  <div fxLayout="column" fxFlex="100">
                    <div>
                      <div style="padding: 12px;" class="jumbotron text-center" fxLayout="row" fxLayout.md="column" fxLayout.sm="column" fxLayout.xs="column">
                        <div fxFlex="20" fxLayout="column">
                          <h1 class="subHeader" style="line-height: 60px;">
                            Box Copter Hero
                          </h1>
                          <div class="image_icon" style="padding: 12px;">
                            <img style="width: 200px; height: 200px; margin-bottom: 24px;" src="assets/images/game-icons/box-copter-hero-icon.png">
                          </div>
                        </div>
                        <div fxFlex="80" fxLayout="column">
                          <h1>Overview</h1>
                          <em class="box-copter-hero-text" style="display: inline-block !important; color: #fff; font-size: 24px; line-height: 76px !important; font-family: 'Raleway', sans-serif;">
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-start.png" />
                            Control the box copter by tapping on screen to change direction, using momentum to dodge birds and ascending gears. With 24 unique characters to choose from, leaderboards support, and fun, addicting gameplay, Box Copter Hero is a game to play for those who want a challenge.
                            <img style="width: 50px; height: 50px;" src="assets/images/large-quote-end.png" />
                          </em>
                          <mat-divider style="border-top-width: 1px; border-top-color: #fff;"></mat-divider>
                          <h1>
                            External Links
                          </h1>
                          <a (click)="navigate('https://www.behance.net/gallery/84034917/Box-Copter-Hero')" style="padding: 6px;"><img src="assets/images/icons/behance.png" style="width: 32px; height: 32px;" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</public>
